enum IncomeType {
  DK_SALARY_INCOME = 'DKSalaryIncome',
  DK_B_INCOME = 'DKBIncome',
  DK_RESEARCH_INCOME = 'DKResearchIncome',
  DK_CONTRIBUTION_FREE = 'DKContributionFree',
  DK_CONTRIBUTION_FREE_AM = 'DKContributionFreeAM',
  DK_CONTRIBUTION_FREE_ABROAD = 'DKContributionFreeAbroad',
}
export default IncomeType
